import getHelper from '../../../services/getHelper';

export default getHelper('/training-plans');
